import Movie from "../../assets/movieapi.jpeg";
import dad from "../../assets/dadjokes.jpeg";
// import Todo from "../../assets/todo.png"
import Realtor from "../../assets/realtor.png"
import password from "../../assets/password.png"
import mydb from "../../assets/mydb.png"
import bigyes from "../../assets/bigyes.png"
import toddlersmash from "../../assets/toddlersmash.png"
import get10k from "../../assets/get10k.png"
export const projectsData = [
  {
    id: 9,
    image: get10k,
    title: "get10k",
    category: "web",
    url: "https://www.get10000shots.com/",
    description: "10000 Shot Club — basketball training app landing page, shot logging, streaks, coach squads & join codes",
  },
  {
    id: 8,
    image: toddlersmash,
    title: "Toddler Smash",
    category: "web",
    url: "https://www.toddlersmash.com/",
    description: "Sensory web game for ages 6mo–3yr — touch & keyboard input, sounds, 4 themes, parent-safe timers",
  },
  {
    id: 1,
    image: bigyes,
    title: "Big Yes Energy",
    category: "web",
    url: "https://bigyesenergy.com/",
    description: "Next.js, TypeScript, Supabase, OpenAI, Tailwind, Framer Motion, Vercel",
  },
  // {
  //   id: 2,
  //   image: Todo,
  //   title: "React- Todo List",
  //   category: "web",
  //   url: "https://todolist-indol-psi.vercel.app/"
  // },
  {
    id: 3,
    image: Realtor,
    title: "Realtor App",
    category: "app",
    url: "https://realestate-api-next.vercel.app/"
  },
  {
    id: 4,
    image: password,
    title: "React- Password Generator",
    category: "app",
    url: "https://passwordgenerator-swart-gamma.vercel.app/"
  },
  {
    id: 5,
    image: Movie,
    title: "Movie API",
    category: "app",
    url: "https://movieapi-kappa.vercel.app/",
  },
  {
    id: 6,
    image: dad,
    title: "Dad Jokes API",
    category: "app",
    url: 'https://dadjokes-liart.vercel.app/', 
  },
  {
    id: 7,
    image: mydb,
    title: "MyDB Solutions homepage",
    category: "web",
    url: "https://mydbboot.vercel.app/",
  },
];

// projects
export const projectsNav = [
  // {
  //   name: "all",
  // },
  // // {
  // //   name: "web",
  // // },
  // // {
  // //   name: "app",
  // // },
  // // {
  // //   name: "design",
  // // },
];
